import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { N500 } from '@atlaskit/theme/colors';
import { Environment } from '@atlassiansox/bxpkit-core';
import OriginTracing from '@atlassiansox/origin-tracing';
import styled from '@emotion/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../messages';
import { fontCharlieText } from '../styled';

export function ButtonGoogleSignIn() {
  const { createAnalyticsEvent } = useAnalyticsEvents();
  const loginGoogleOrigin = new OriginTracing({ product: 'wac-signup-google' });

  const cobranding = `application=wac`;
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.append('social-signup-login', 'true');
  const continueUrl = `&continue=${encodeURIComponent(currentUrl.href)}`;
  const accountPrompt = `&prompt=select_account`;
  const atlOrigin = `&atlOrigin=${encodeURIComponent(
    loginGoogleOrigin.encode()
  )}`;
  const urlGoogleSignupContinue = `${Environment.getIdentityBaseUrl()}/login/initiate/google?${cobranding}${atlOrigin}${continueUrl}${accountPrompt}`;

  const googleButtonClick = () => {
    createAnalyticsEvent({
      eventName: 'wac-signup-google',
      eventComponent: 'button',
      event: 'clicked',
      devops: 'true'
    }).fire();
  };

  return (
    <SocialButton
      href={urlGoogleSignupContinue}
      onClick={googleButtonClick}
      id={'devops-google-sign-in-button'}
      className={'social-signup-button google'}
    >
      <SocialButtonIcon src="https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/5.0.51/static/media/google-logo.c21ca9d1.svg" />{' '}
      <FormattedMessage {...messages.socialSignUpButtonContinueWithGoogle} />
    </SocialButton>
  );
}

const SocialButton = styled.a`
  text-decoration: none;
  height: 39px;
  width: 100%;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${N500};
  :hover {
    color: ${N500};
    text-decoration: none;
  }
  cursor: pointer;
  font-weight: 500;
  box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 5px 0 !important;
  background-color: #fff;

  margin: 0px 0px 20px 0px;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  font-family: ${fontCharlieText};
  font-style: normal;
`;
const SocialButtonIcon = styled.img`
  height: 18px;
  width: 18px;
  margin-right: 8px;
  margin-bottom: 0;
`;
